<template>
<section class="page-journal">
  <div class="qbk-header">
    <img src="../assets/images/logo-red.svg" alt="">
  </div>
  <div class="qbk-journal-thumb">
    <div class="qbk-wrap">
      <div class="qbk-journal-heading">
        <h1>Whats New</h1>
        <!-- <router-link to="/journal">View All</router-link> -->
      </div>
      <div class="row">
        <div class="col-12 col-md-4 mb-5" v-for="(jt,jtIndex) in journal" :key="'qbk-jt-item-'+jtIndex">
          <div class="qbk-jt-item">
            <router-link :to="`/journal/${jt.id}`">
              <img :src="jt.image" alt="" class="img-fluid w-100">
              <div class="qbk-jti-content">
                <h3>{{jt.title}}</h3>
                <h6>{{jt.summary}}</h6>
                <label>{{jt.date}}</label>
                <p>{{limitWord(jt.content,100)}}...</p>
                <span>Read More</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="qbk-journal-thumb" v-show="false">
    <div class="qbk-wrap">
      <div class="qbk-journal-heading">
        <h1>Trending Post</h1>
        <router-link to="/journal">View All</router-link>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 mb-3" v-for="(jtp,jtpIndex) in journal" :key="'qbk-jtp-item-'+jtpIndex">
            <router-link :to="`/journal/${jtp.id}`">
            <div class="qbk-jt-item">
              <img :src="jtp.image" alt="" class="img-fluid w-100">
              <div class="qbk-jti-content">
                <h3>{{jtp.title}}</h3>
                <h6>{{jtp.summary}}</h6>
                <label>{{jtp.date}}</label>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <div class="qbk-journal-popular" v-show="false">
    <div class="qbk-wrap">
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="qbk-jp-popular">
            <b-carousel id="qbk-jpp-slider" :interval="4000" controls fade>
              <b-carousel-slide v-for="(n,index) in journal" :key="'qbk-jpp-item-'+index">
                <template v-slot:img>
                  <img :src="n.image">
                </template>
                <div class="qbk-jpp-item">
                  <router-link :to="`/journal/${n.id}`">
                    <span>Popular</span>
                    <h1>{{n.title}}</h1>
                    <label>{{n.date}}</label>
                  </router-link>
                </div>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="qbk-jp-latest">
            <h1>Latest Post</h1>
            <hooper :settings="hooperSettings" style="height: 277px">
              <slide v-for="(f,fIndex) in journal" :key="'qbk-jpl-in-'+fIndex" class="qbk-jpl-slide">
                <div v-for="(x,xIndex) in journal" :key="'qbk-jpl-in-'+xIndex" v-show="xIndex < 3">
                  <router-link :to="`/journal/${x.id}`">
                    <h4>{{x.title}}</h4>
                    <label>{{x.date}}</label>
                  </router-link>
                </div>
              </slide>
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="qbk-journal-thumb mb-5" v-show="false">
    <div class="qbk-wrap">
      <div class="qbk-journal-heading">
        <h1>Follow Us on Instagram</h1>
      </div>
      <div class="row">
        <div class="col-12 col-md-4" v-for="(jtp,index) in 3" :key="'qbk-jig-item-'+index">
          <div class="qbk-jig-item">
            <img :src="require('../assets/images/journal/insta-'+jtp+'.png')" alt="" class="img-fluid w-100">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import axios from 'axios'
import {baseUrl} from '../config'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation
} from 'hooper';
export default {
  name: 'journal',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  data() {
    return {
      hooperSettings: {
        itemsToShow: 1,
        itemsToSlide: 1,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 5000,
        vertical: true
      },
      journal : []
    };
  },
  methods: {
    loadJournal(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : '~',
        type : 'JOURNAL ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.journal = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    thousand(num) {
      if (num) {
        let num_parts = num.toString().split(",");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return num_parts.join(",");
      } else {
        return 0
      }
    },
    limitWord(yourString,maxLength){
      let string = yourString.replace(/<[^>]*>?/gm, '');
      //trim the string to the maximum length
      var trimmedString = string.substr(0, maxLength);

      //re-trim if we are in the middle of a word
      return trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
  },
  mounted(){
    this.loadJournal()
  }
}
</script>
